
import {
  defineComponent, reactive, watch,
} from 'vue';
import Icone from '@/core/components/Icone.vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import { useModalBase } from '@/core/composables/ModalBase';
import Card from '@/core/components/Tela/Card.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import SelecionarProduto from '@/components/Cadastros/Produtos/SelecionarProduto.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import ServicoEstoque from '@/servicos/Cadastros/Estoques/ServicoEstoque';
import ServicoCfop from '@/servicos/Cadastros/Tributacoes/ServicoCfop';
import UtilitarioDispositivo from '@/core/utilitarios/UtilitarioDispositivo';
import ServicoCalculosComerciais from '@/servicos/ServicoCalculosComerciais';
import SelecionarUnidadeProdutoMovimento from '@/components/Cadastros/Produtos/Unidades/SelecionarUnidadeProdutoMovimento.vue';
import { IPedidoCompraItem, IPedidoCompraItemImposto } from '@/models/Entidades/Compras/IPedidoCompra';

export default defineComponent({
  name: 'PedidoCompraItemModal',
  props: {
    visivel: {
      type: Boolean,
    },
    empresa: {
      type: Number,
      required: true,
    },
    editavel: {
      type: Boolean,
      default: true,
    },
    item: {
      type: Object as () => IPedidoCompraItem,
      required: true,
    },
    totalNota: {
      type: Number,
      required: true,
    },
    existeProximo: {
      type: Boolean,
      required: true,
    },
    existeAnterior: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Card,
    Icone,
    SelecionarProduto,
    SelecionarUnidadeProdutoMovimento,
    CampoNumerico,
  },
  emits: ['update:visivel', 'salvar', 'proximoItem', 'itemAnterior'],
  setup(props, { emit }) {
    const servicoEstoque = new ServicoEstoque();
    const servicoCfop = new ServicoCfop();
    const servicoCalculosComerciais = new ServicoCalculosComerciais();
    servicoEstoque.requisicaoSistema();
    servicoCfop.requisicaoSistema();

    const { telaBase, apresentarMensagemAlerta } = useTelaBase();
    const { modalBase } = useModalBase(props, emit);

    const state = reactive({
      item: {} as IPedidoCompraItem,
      totalNota: 0,
      telaMobile: false,
    });

    function instanciaNovoItem():IPedidoCompraItem {
      const itemPedidoCompra = {} as IPedidoCompraItem;
      itemPedidoCompra.codigoProdutoDefinicao = 0;
      itemPedidoCompra.unidade = 0;
      itemPedidoCompra.siglaUnidade = '';
      itemPedidoCompra.valorTotal = 0;
      itemPedidoCompra.valorUnitario = 0;
      itemPedidoCompra.imposto = {} as IPedidoCompraItemImposto;
      itemPedidoCompra.imposto.valorIcms = 0;
      itemPedidoCompra.imposto.valorIpi = 0;
      return itemPedidoCompra;
    }

    function limparCampos() {
      state.item = instanciaNovoItem();
      state.totalNota = 0;
      state.telaMobile = UtilitarioDispositivo.larguraTelaMobile();
    }

    function calcularTotalNota() {
      state.totalNota = props.totalNota;
      state.totalNota += state.item.valorTotal;
    }

    function validarCampos() {
      if (state.item.codigoProdutoDefinicao === undefined || state.item.codigoProdutoDefinicao === 0) {
        apresentarMensagemAlerta('O Produto deve ser informado!');
        return false;
      }

      if (state.item.unidade === undefined || state.item.unidade === 0) {
        apresentarMensagemAlerta('A Unidade deve ser informada!');
        return false;
      }

      if (state.item.quantidade === undefined || state.item.quantidade < 1) {
        apresentarMensagemAlerta('A Quantidade deve ser informada!');
        return false;
      }

      if (state.item.valorTotal === undefined || state.item.valorTotal < 1) {
        apresentarMensagemAlerta('O Total do Item deve ser informado!');
        return false;
      }

      return true;
    }

    function calculaTotalItemEAtualizaTotalNota() {
      state.item.valorTotal = servicoCalculosComerciais.calculaValorTotal(state.item.quantidade, state.item.valorUnitario, state.item.desconto, 0);
      calcularTotalNota();
    }

    function salvar() {
      if (validarCampos()) {
        if (state.item.codigo === undefined) {
          state.item.codigo = 0;
        } else {
          state.item.alterado = true;
        }
        emit('salvar', state.item);
      }
    }

    async function proximoItem() {
      emit('proximoItem');
    }

    async function itemAnterior() {
      emit('itemAnterior');
    }

    async function calcularTributacoes() {
      const retornoCalculoTributacoes = await servicoCalculosComerciais.CalcularTributacoesPedidoCompra(state.item);
      if (UtilitarioGeral.objetoValido(retornoCalculoTributacoes)) {
        state.item.imposto.valorIcms = retornoCalculoTributacoes.icms.valorIcms;
        state.item.imposto.valorIpi = retornoCalculoTributacoes.ipi.valor;
      }
    }

    watch(async () => modalBase.computedVisivel, async () => {
      telaBase.carregando = true;
      limparCampos();
      if (modalBase.computedVisivel) {
        state.item = UtilitarioGeral.clonarObjeto(props.item);
      }
      telaBase.carregando = false;
    });

    watch(async () => props.item, async () => {
      state.item = props.item;
    });

    return {
      props,
      state,
      telaBase,
      modalBase,
      UtilitarioGeral,
      UtilitarioMascara,
      salvar,
      proximoItem,
      itemAnterior,
      calcularTotalNota,
      calculaTotalItemEAtualizaTotalNota,
      calcularTributacoes,
    };
  },
});
